<script>
  import { Handle, Position } from "@xyflow/svelte";
  import { fly } from "svelte/transition";

  export let data;
  export let isConnectable = false;
  export let id;

  let {
    label,
    icon,
    isStart,
    isEnd,
    color,
    handlemodal,
    position,
    seeIcon = true,
    seeButton = true,
    windowSequence = [],
    hasWindowSequence = false,
    windowSequenceOpen = false,
    handleWindowSequenceToggle,
  } = data;

  $: isSelected = data.isSelected;

  $$restProps;

  function handleClick(e) {
    e.preventDefault();
    handlemodal(e, id);
  }

  function handleWindowSequenceClick(e) {
    e.preventDefault();
    e.stopPropagation();
    handleWindowSequenceToggle?.(id);
  }

  function htmlToText(html) {
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    const parts = tempDivElement.innerHTML.split("<br>");
    const windowTitleAndElement = parts.slice(-2).join("\n");
    return windowTitleAndElement || "";
  }
</script>

{#if isStart}
  <Handle
    type="source"
    position={Position.Bottom}
    style="background: #555;"
    {isConnectable}
    class="customHandle"
  />
{:else}
  <Handle
    type="target"
    position={Position.Top}
    style="background: #555;"
    {isConnectable}
    class="customHandle"
  />
{/if}
<div class="container">
  <div
    data-node-id={id}
    class="custom-node {isStart || isEnd ? 'start-end-node' : ''}
  {isSelected ? 'selected' : ''} {(isStart || isEnd) && !seeIcon
      ? 'no-icon'
      : ''}"
    style={`background: ${!isStart && !isEnd ? color : ""};`}
    in:fly={{ x: position.x, y: position.y, duration: 500 }}
  >
    <div class="node-main">
      {#if seeIcon}
        <img
          src={icon}
          alt="icon"
          width="35"
          height="30"
          style={isStart || isEnd ? "filter: invert(1);" : ""}
        />
      {:else}
        <div class="icon-placeholder"></div>
      {/if}
      <span class="label-node" title={htmlToText(label)}>{@html label}</span>
      {#if !isEnd && !isStart && seeButton}
        <button
          class="sequence-toggle"
          title={hasWindowSequence ? "Show window sequence" : "Node options"}
          on:click={hasWindowSequence ? handleWindowSequenceClick : handleClick}
        >
          {#if hasWindowSequence}
            <span>{windowSequenceOpen ? "−" : "+"}</span>
          {:else}
            <img
              alt="icon button"
              class="more_filled_icon undefined"
              src="/img/ui_icons/more.svg"
              width="30"
              height="30"
            />
          {/if}
        </button>
      {/if}
    </div>
    {#if !isEnd && !isStart && windowSequence.length}
      <div class="window-sequence">
        {#each windowSequence as item, index}
          <div class="window-sequence-row">
            <span title={`${item.app ? `${item.app}: ` : ""}${item.windowTitle || ""}`}>
              {index + 1}. {item.app ? `${item.app}: ` : ""}{item.windowTitle}
            </span>
            <strong>[{item.count}]</strong>
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>

{#if !isStart && !isEnd}
  <Handle
    type="source"
    position={Position.Bottom}
    style="background: #555; cursor: pointer;"
    {isConnectable}
    class="customHandle"
  />
{/if}

<style>
  .container {
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-node {
    display: flex;
    font-size: 14px;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    padding: 14px 16px;
    border: 2px solid #000;
    border-radius: 8px;
    gap: 10px;
  }

  .node-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .custom-node:hover {
    border: 2px solid #ff5f1f;
  }

  :global(.svelte-flow__node .node_hovered) {
    stroke: #ff5f1f !important;
  }

  .selected {
    border: 2px solid #5c25fa;
  }

  .start-end-node {
    background: #000;
    border: 2px solid #000;
    border-radius: 10px;
    color: #fff;
  }

  :global(div.customHandle) {
    border-radius: 0;
    transform: none;
    border: none;
    opacity: 0;
  }

  .label-node {
    max-width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1px 0;
  }

  .window-sequence {
    border-top: 1px solid #d7d7d7;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding-top: 6px;
  }

  .window-sequence-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;
    min-height: 26px;
    border-bottom: 1px solid #e4e4e4;
    color: #111827;
  }

  .window-sequence-row:last-child {
    border-bottom: none;
  }

  .window-sequence-row span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .window-sequence-row strong {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 2px 6px;
    background: #fff;
    font-weight: 600;
  }

  .sequence-toggle {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .sequence-toggle span {
    display: block;
    font-size: 24px;
    font-weight: 500;
    line-height: 1;
  }

  .no-icon {
    padding-right: 35px;
    padding-left: 30px;
  }

  .icon-placeholder {
    height: 30px;
    display: inline-block;
  }
</style>
